import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

interface Department { id: string; name: string }
interface Props { staffId: string; staffName: string; onClose: () => void; onSuccess: () => void }

export default function ShiftPermissionModal({ staffId, staffName, onClose, onSuccess }: Props) {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [enabled, setEnabled] = useState<string[]>([]);
  const [initial, setInitial] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    supabase.rpc('admin_get_shift_manager_scopes', { p_staff_id: staffId }).then(({ data }) => {
      const result = data as { departments?: Department[]; enabled_department_ids?: string[] } | null;
      setDepartments(result?.departments || []); setEnabled(result?.enabled_department_ids || []); setInitial(result?.enabled_department_ids || []); setLoading(false);
    });
  }, [staffId]);

  const save = async () => {
    setSaving(true);
    const ids = [...new Set([...initial, ...enabled])];
    for (const id of ids) {
      const shouldEnable = enabled.includes(id);
      if (initial.includes(id) === shouldEnable) continue;
      const { error } = await supabase.rpc('admin_set_shift_manager_scope', { p_staff_id: staffId, p_department_id: id, p_enabled: shouldEnable });
      if (error) { setSaving(false); return; }
    }
    setSaving(false); onSuccess();
  };

  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"><div className="w-full max-w-md rounded-xl bg-background-50 border border-background-200 p-5">
    <div className="flex justify-between mb-4"><div><h3 className="font-semibold text-foreground-900">シフト作成権限</h3><p className="text-sm text-foreground-600 mt-1">{staffName}</p></div><button onClick={onClose}><i className="ri-close-line text-xl" /></button></div>
    <p className="text-xs text-foreground-600 bg-background-100 rounded-lg p-3 mb-4">選択した部署のシフトだけ作成・編集・公開できます。給与・契約書・マイナンバーの権限は付与されません。</p>
    {loading ? <div className="py-8 text-center">読み込み中…</div> : <div className="space-y-2">{departments.map((department) => <label key={department.id} className="flex items-center gap-3 rounded-lg border border-background-200 px-3 py-2.5"><input type="checkbox" checked={enabled.includes(department.id)} onChange={(e) => setEnabled((current) => e.target.checked ? [...current, department.id] : current.filter((id) => id !== department.id))} /><span className="text-sm">{department.name}</span></label>)}</div>}
    <div className="flex gap-3 mt-5"><button onClick={onClose} className="flex-1 px-4 py-2.5 rounded-lg border border-background-200">閉じる</button><button onClick={save} disabled={saving || loading} className="flex-1 px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 font-semibold disabled:opacity-60">{saving ? '保存中…' : '保存'}</button></div>
  </div></div>;
}
